import Form from "react-bootstrap/Form";
import React, {useEffect, useState} from "react";
import {MdExpandLess} from "@react-icons/all-files/md/MdExpandLess";
import {MdExpandMore} from "@react-icons/all-files/md/MdExpandMore";
import {useTekstClient} from "hooks/useTekstClient";
import {useSetSearchParams} from "hooks/useSetSearchParams";
import _ from "lodash";
import {useSearchParams} from 'next/navigation'
import useGebruiker from "../../../../hooks/useGebruiker";


const FilterAutorisatie = () => {
    const {ingelogdeGebruiker} = useGebruiker()
    const [expand, setExpand] = useState(true);
    const {tekst, isLoadingTekst} = useTekstClient()
    const searchParams = useSearchParams()
    const {deleteParam, updateParam} = useSetSearchParams()
    const filterUnlock = searchParams.get('unlock')


    const unlockParams = filterUnlock ? filterUnlock.split(',').map(x => parseInt(x)) : []
    const setFilter = (checked, id) => {
        if (checked) {
            !unlockParams.includes(id) && updateParam('unlock', [...unlockParams, id].join(','))
        } else if (unlockParams.includes(id)) {
            let tmpUnlock = [...unlockParams].filter(x => x !== id).join(',')
            if (tmpUnlock.length === 0) {
                deleteParam('unlock')
            } else {
                updateParam('unlock', tmpUnlock)
            }
        }

    }


    //TODO: Refactor nodig. Waarom hardcoded types gebruiken hier.
    // Als er een type bijkomt kunnen we alles weer aanpassen.
    return <>
        {ingelogdeGebruiker &&
            <div>
                <div>
                    <b className={`flex items-center cursor-pointer`} onClick={() => setExpand(!expand)}>
                        {expand
                            ? <MdExpandLess />
                            : <MdExpandMore />
                        }
                        {tekst('pagina:support:kenniscentrum:autorisatie:titel')}
                    </b>
                </div>
                {expand &&

                    <div className={'ml-3'} style={{position: "relative"}}>

                        <Form.Check
                            type={'checkbox'}
                            id={`filterIsToegekend-0`}
                            checked={unlockParams.includes(0)}
                            label={tekst('pagina:support:kenniscentrum:autorisatie:openbaar')}
                            onChange={(e) => setFilter(e.target.checked, 0)}
                        />
                        <Form.Check
                            type={'checkbox'}
                            id={`filterIsToegekend-1`}
                            checked={unlockParams.includes(1)}
                            label={tekst('pagina:support:kenniscentrum:autorisatie:inlog_vereist')}
                            onChange={(e) => setFilter(e.target.checked, 1)}
                        />
                        {ingelogdeGebruiker.groep?.mkger &&
                            <>
                                <Form.Check
                                    type={'checkbox'}
                                    id={`filterIsToegekend-2`}
                                    checked={unlockParams.includes(2)}
                                    label={tekst('pagina:support:kenniscentrum:autorisatie:MKG intern')}
                                    onChange={(e) => setFilter(e.target.checked, 2)}
                                />
                                <Form.Check
                                    type={'checkbox'}
                                    id={`filterIsToegekend-3`}
                                    checked={unlockParams.includes(3)}
                                    label={tekst('pagina:support:kenniscentrum:autorisatie:prive')}
                                    onChange={(e) => setFilter(e.target.checked, 3)}
                                />
                            </>
                        }
                    </div>

                }

                <div className={`border-b border-kleur-licht-grijs-blauw pb-[20px] mb-[20px]`}/>
            </div>
        }
    </>

}
export default FilterAutorisatie;